import { render, staticRenderFns } from "./dateCard.vue?vue&type=template&id=fa74271a&"
import script from "./dateCard.vue?vue&type=script&lang=js&"
export * from "./dateCard.vue?vue&type=script&lang=js&"
import style0 from "./dateCard.vue?vue&type=style&index=0&id=fa74271a&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports